import React from 'react';
import { motion } from 'framer-motion';
import { useLandingTranslations } from '../contexts/LandingTranslationContext';

const Footer = () => {
  const { translations } = useLandingTranslations();

  return (
    <motion.footer
      className="py-6 text-center text-white"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
    >
      <div className="flex flex-col items-center space-y-4">
        <motion.img
          src="/logo_transparent.png"
          alt="ctrlcv logo"
          className="h-12 w-auto mb-2"
          whileHover={{ scale: 1.05 }}
        />
        <p>{translations.footer.copyright}</p>
      </div>
    </motion.footer>
  );
};

export default Footer; 